export const FILTER_OPTIONS = [
  { id: "replied", name: "Replied" },
  { id: "not_replied", name: "Not replied" },
  { id: "disabled", name: "Disabled" },
  { id: "scheduled_call", name: "Scheduled call" },
  { id: "calendar_confirmed", name: "Calendar confirmed" },
  { id: "takeover", name: "Takeover" },
  { id: "immediate_call", name: "Immediate call" },
  { id: "scheduled", name: "After hours" }
] as const

export const TAKEOVER_PREFIX = "** LO Takeover: "
